import { IMenusModel } from "./AppMenus"
import { ICoordinates } from "./Common"

export interface IProjectLink {
    Type: "tel" | "email" | "link",
    Name: string,
    Url: string,
    Header: boolean,
    Footer: boolean
}

export interface IProjectSettings {
    IsComingSoon: boolean,
    IsPublished: boolean,
    Project:
    {
        Id: string,
        Title: string,
        TitleHTML: string,
        Subtitle: string,
        Domain: string,
        Keywords: string,
        Description: string,
        ShareImage: string,
        Folder?: string,
        Version: string,
        WalletEntityType?: EnumWalletEntityType,
    },
    Configuration:
    {
        Logos:
        {
            Main: string,
            Header: string,
            Login: string
        },
        DefaultImage?: string,
        Cards?: {
            Modules?: number[],
            Images?: { Front?: string, Back?: string },
            ProofDocuments?: {
                Id?: string,
                Type?: number,
                Required?: boolean,
                Enabled?: boolean,
                Name?: string,
                ControlName: string,
                Description?: string
            }[]
        }[],
        Letter: {
            Type: number,
            Template: string, // imagem png
            AddressToSend?: { Street: string, ZipCode: string, Locality: string }
        },
        PrintOptions: {
            EnabledValidationDate: boolean
        },
        Documentation: { Name: string, Url: string, IsEnabled: boolean }[],
        MarketPlace: {
            Enable: boolean,
            Compliance: {
                Id: number,
                Type: number,
                Method: number,
                Name: string,
                Resource: string,
                Url: string,
                Description: string,
                ControlName: string,
                Enabled: boolean
            }
        }
    }
    GoogleMaps: {
        Key: string
    },
    SEO:
    {
        GoogleAnalytics: string,
        GoogleSiteVerification: string
    }
    Coordinates: ICoordinates,
    Menus: IMenusModel[],
    Links: IProjectLink[],
    Contacts: IProjectLink[],
    OpeningHours: string,
    MerchantsRequests:
    {
        StartDate: string,
        EndDate: string
    },
    CouponRegistration:
    {
        StartDate: string,
        EndDate: string
    }
    NotifyUserAlerts: boolean,
    Pages:
    {
        Home: IProjectSettingsPages,
        Drafts?: {
            Banner?: {
                Url: string
            },
            Background?: {
                Url: string
            }
        },
        Merchants?: {
            Source?: any
        },
        Consumer?: {
            RequiredEmail?: boolean;
            Source?: any
        },
        ConsumerChargings?: {
            Templates?: IConsumerChargingTemplate[]
        },
        Movements?: {
            ReadInvoiceMerchantMatch?: string[],
            ConsumptionMinDays?: number,
            ConsumptionMaxDays?: number
        },
        RequestsCard?: {
            WalletEntityType?: EnumWalletEntityType,
            IdProject?: number
        }
    },
    ApplicationDocuments: IProjectApplicationDocuments[],
    EquipmentTypes?: IEquipmentTypeConfig[],
    ConsumptionAttachments?: IProjectApplicationDocuments[]

}

export interface IProjectApplicationDocuments {
    Type: number,
    Name: string,
    Required: boolean,
    IsEnabled: boolean,
    Module?: number[],
    SubTitle?: string,
    Description?: string,
    MCC?: string[],
    MerchantNameMatch?: string[]
}

export enum EnumWalletEntityType {
    None = 'none',
    Payshop = 'Payshop',
    SIBS = 'SIBS'
}

export enum EnumRequestsCardIdProject {
    Payshop = 2,
    SIBS = 7,
    MicroIO = 10
}

export interface IEquipmentTypeConfig {
    IdProject: number;
    Name: string;
    Enabled: boolean;
    Description?: string;
}

export interface IConsumerChargingTemplate {
    Enable: boolean,
    Path: string,
    Type: number,
    Name: string,
    Columns?: IConsumerChargingTemplateColumns
}

export interface IConsumerChargingTemplateColumns {
    NIF: number,
    Value: number,
    Name: number,
    StartRow: number
}

export interface IProjectSettingsPages {
    Header:
    {
        Title: string,
        Images: { Alt?: string, Url: string }[],
        Description: string
    },
    Sections:
    {
        Title: string,
        Side?: 'left' | 'right' | 'none',
        Background?: string,
        Color?: string,
        Image: { Alt?: string, Url: string },
        Description: string,
        Buttons?:
        {
            Label: string,
            Path: string,
            Icon?: string,
            Color?: string,
            External?: boolean
        }[]
    }[]
}
